import React from 'react';
import { Button, styled } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useToggle from '../../hooks/useToggle';
import { useProject } from '../../reactQuery/projects/queries/useProject';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import ProjectForm from '../../component/forms/ProjectForm';
import { setCurrentProject } from '../../actions/ProjectAction';

const Wrapper = styled('div')({
  padding: '1.5rem'
});

const ButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '1rem',
  marginLeft: '35px',
  width: '160px'
});

const DetailsWrapper = styled('div')({
  border: '1px solid #ccc',
  borderRadius: '0.4rem',
  marginLeft: '35px',
  maxWidth: '44rem',
  padding: '1rem'
});

const ContentInner = styled('div')({
  '&:last-child': {
    paddingBottom: '0'
  },
  display: 'flex',
  justifyContent: 'flex-start',
  paddingBottom: '1rem'
});

const Heading = styled('div')({
  fontWeight: 'bold',
  minWidth: '9rem',
  textAlign: 'start'
});

const Detail = styled('div')({
  fontSize: '0.875rem',
  minWidth: '27rem',
  textAlign: 'start'
});

const ProjectDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { projectId } = useParams();
  const { open, handleOpen, handleClose } = useToggle();
  const { data: project, isLoading } = useProject(projectId);

  const resolvedProject = {
    API_KEY: project.api_key,
    Name: project.name,
    PRIVATE_API_KEY: project.private_api_key,
    Tags: project.tags
  };

  function selectProject() {
    if (!project._id) return;
    dispatch(setCurrentProject(project));
    history.push('/content-model');
  }

  return (
    <Wrapper>
      <InnerHeader title="Resource Details" />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <ButtonWrapper>
            <Button color="primary" onClick={handleOpen} variant="contained">
              Edit
            </Button>
            <Button color="primary" onClick={selectProject} variant="contained">
              Select
            </Button>
          </ButtonWrapper>
          <DetailsWrapper>
            {Object.keys(resolvedProject).map((projectKey, idx) => {
              const value = resolvedProject[projectKey];
              return (
                <ContentInner key={idx}>
                  <Heading>{projectKey}:</Heading>
                  <Detail>
                    <Copy text={Array.isArray(value) ? value.join(', ') : value} />
                  </Detail>
                </ContentInner>
              );
            })}
          </DetailsWrapper>
          <ProjectForm
            handleClose={handleClose}
            open={open}
            project={project}
            projectId={projectId}
          />
        </>
      )}
    </Wrapper>
  );
};

export default ProjectDetails;
